import React from 'react';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, modules } from '../data/fono';
export function ModulesSection() {
  return <section className="border-y-4 border-mint bg-white px-3 py-5 sm:py-7" data-id="element-91" data-mp="1ntd2fjl7rx5d">
      <div className="mx-auto max-w-4xl" data-id="element-92" data-mp="1iwmkeqpumrhb">
        <h2 className="text-center text-xl leading-tight text-teal sm:text-3xl" data-id="element-93" data-mp="1it8j7lsx8obg">
          What’s Inside
        </h2>

        <div className="mt-3 grid gap-2.5 sm:grid-cols-2" data-id="element-94" data-mp="2bjyz6eprpv02">
          {modules.map(module => <a key={module.num} href={OFFER_ANCHOR} className="flex flex-col rounded-lg border border-teal/15 bg-cream p-3.5 shadow-sm transition-colors duration-150 hover:border-turq" data-id="element-95" data-mp="26lfbo9vj0b5l">
              <p className="text-[11px] font-extrabold uppercase tracking-wide text-turq" data-id="element-96" data-mp="1wm6lls3s7goi">
                ✅ Module {module.num}
              </p>
              <h3 className="mt-0.5 text-sm leading-tight text-teal sm:text-base" data-id="element-97" data-mp="l7t02twi3dbn">
                {module.title}
              </h3>
              <p className="mt-1.5 text-[13px] font-medium leading-snug text-charcoal/80" data-id="element-98" data-mp="1iuz12ai77nys">
                {module.body}
              </p>
              {module.note && <p className="mt-1.5 text-[13px] font-medium leading-snug text-charcoal/70" data-id="element-99" data-mp="18xb4rg4y28ei">
                  {module.note}
                </p>}
              <p className="mt-auto pt-2 text-[13px] font-extrabold text-coral" data-id="element-100" data-mp="1duazww099qqu">
                {module.kicker}
              </p>
            </a>)}
        </div>

        <CTAButton className="mx-auto mt-3 max-w-md" data-id="element-101" data-mp="14wit6g8lnrf2">
          🗣️ YES! I WANT THE COMPLETE SYSTEM
        </CTAButton>
      </div>
    </section>;
}